import { useId } from 'react';
import styled from 'styled-components';

const PatternSvg = styled.svg`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  mix-blend-mode: overlay;
  opacity: var(--diamond-pattern-opacity, 0.7);
  pointer-events: none;
`;

const DEFAULT_WIDTH = 70;
const DEFAULT_HEIGHT = 40;

type Props = {
  width?: number;
  height?: number;
  className?: string;
  startFromBottom?: boolean;
};

/**
 * Renders a tessellating diamond pattern where adjacent diamonds alternate
 * between lighter and darker fills, producing a chess-board effect.
 * Each pattern tile contains one center diamond (lighter) whose surrounding
 * corner triangles combine with neighboring tiles to form the darker diamonds.
 */
export const DiamondPatternBackground = ({
  width = DEFAULT_WIDTH,
  height = DEFAULT_HEIGHT,
  className,
  startFromBottom = false,
}: Props) => {
  const patternId = useId();
  const halfW = width * 0.5;
  const halfH = height * 0.5;
  const diamondPath = `M ${halfW} 0 L ${width} ${halfH} L ${halfW} ${height} L 0 ${halfH} Z`;

  return (
    <PatternSvg className={className}>
      <pattern
        id={patternId}
        x="50%"
        y={startFromBottom ? '100%' : '50%'}
        width={width}
        height={height}
        patternUnits="userSpaceOnUse"
        viewBox={`0 0 ${width} ${height}`}
      >
        <rect width={width} height={height} fill="rgba(255,255,255,0.02)" />
        <path
          d={diamondPath}
          fill="rgba(255,255,255,0.1)"
          stroke="lightgray"
          strokeOpacity={0.4}
          strokeWidth={1.5}
        />
      </pattern>
      <rect width="100%" height="100%" fill={`url(#${patternId})`} />
    </PatternSvg>
  );
};
